import script from "./RatesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./RatesTab.vue?vue&type=script&setup=true&lang=js"

import "./RatesTab.vue?vue&type=style&index=0&id=9cc29eca&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cc29eca"]])

export default __exports__